export default __webpack_public_path__ + "static/media/Carpet.cf844262.png";